import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase.js";
import { formatDateTime } from "../lib/datetime.js";

interface BusinessRow {
  id: string;
  name: string;
}

interface AuditRow {
  id: number;
  actor: string | null;
  business_id: string | null;
  action: string;
  target: string | null;
  at: string;
  detail: unknown;
  businesses: { name: string } | null;
}

export function AuditLog() {
  const [rows, setRows] = useState<AuditRow[]>([]);
  const [businesses, setBusinesses] = useState<BusinessRow[]>([]);
  const [businessFilter, setBusinessFilter] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .from("businesses")
      .select("id, name")
      .order("name")
      .then(({ data }) => setBusinesses((data ?? []) as BusinessRow[]));
  }, []);

  useEffect(() => {
    setLoading(true);
    let query = supabase
      .from("audit_log")
      .select("id, actor, business_id, action, target, at, detail, businesses(name)")
      .order("at", { ascending: false })
      .limit(200);
    if (businessFilter) query = query.eq("business_id", businessFilter);
    query.then(({ data }) => {
      setRows((data ?? []) as unknown as AuditRow[]);
      setLoading(false);
    });
  }, [businessFilter]);

  return (
    <div>
      <h1 className="rc-h1" style={{ marginBottom: 16 }}>Audit log</h1>

      <label style={{ display: "block", marginBottom: 16, fontSize: 14 }}>
        Business
        <select value={businessFilter} onChange={(e) => setBusinessFilter(e.target.value)} style={{ display: "block", padding: 8, marginTop: 4 }}>
          <option value="">All businesses</option>
          {businesses.map((b) => (
            <option key={b.id} value={b.id}>
              {b.name}
            </option>
          ))}
        </select>
      </label>

      {loading ? (
        <p className="rc-loading">Loading...</p>
      ) : (
        <div className="rc-table-scroll"><table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: "left", borderBottom: "1px solid var(--rc-border)", color: "var(--rc-text-muted)" }}>
              <th style={{ padding: "10px 12px" }}>When</th>
              <th style={{ padding: "10px 12px" }}>Business</th>
              <th style={{ padding: "10px 12px" }}>Action</th>
              <th style={{ padding: "10px 12px" }}>Target</th>
              <th style={{ padding: "10px 12px" }}>Detail</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} style={{ borderBottom: "1px solid var(--rc-border-soft)", verticalAlign: "top" }}>
                <td style={{ padding: "10px 12px", whiteSpace: "nowrap" }}>{formatDateTime(r.at)}</td>
                <td style={{ padding: "10px 12px" }}>{r.businesses?.name ?? "-"}</td>
                <td style={{ padding: "10px 12px", fontWeight: 600 }}>{r.action}</td>
                <td style={{ padding: "10px 12px", color: "var(--rc-text-faint)" }}>{r.target ?? "-"}</td>
                <td style={{ padding: "10px 12px" }}>{r.detail ? <pre style={preStyle}>{JSON.stringify(r.detail, null, 2)}</pre> : "-"}</td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr>
                <td colSpan={5} style={{ padding: 16, color: "var(--rc-text-faint)" }}>
                  No audit events yet.
                </td>
              </tr>
            )}
          </tbody>
        </table></div>
      )}
    </div>
  );
}

const preStyle: React.CSSProperties = { margin: 0, fontSize: 12, whiteSpace: "pre-wrap" };
